import {
    Smile, Sparkles, Heart, User, Baby, HeartPulse, Bone, Eye, Ear,
    ScanLine, FlaskConical, Brain, Stethoscope, Pill, Activity,
} from "lucide-react";

const MAP = {
    "Dental Care": Smile,
    "Dermatology & Aesthetics": Sparkles,
    "Women's Health": Heart,
    "Men's Health": User,
    "Pediatrics": Baby,
    "Cardiology": HeartPulse,
    "Orthopedics": Bone,
    "Eye Care": Eye,
    "ENT": Ear,
    "Radiology & Scans": ScanLine,
    "Laboratories": FlaskConical,
    "Mental Health": Brain,
    "Pharmacy": Pill,
    "General Practice": Stethoscope,
};

export function iconForCategory(name_en) {
    return MAP[name_en] || Activity;
}
